<template>
  <div class="helloSvg-wrapper">
    <header class="header" ref="header">
      <ArrowLeft
        class="fold"
        style="width: 2em; height: 2em"
        @click="backHome"
      ></ArrowLeft>
      <span class="title"></span>
    </header>
    <div class="login-content">
      <div class="top">
        <img src="../../../static/images/neicebanBig.png" />
      </div>
      <div class="center">
        <div class="userInfo" v-if="userInfo">
          <p v-if="userInfo.status == 2">
            <span>审核不通过原由：</span>
            <span>{{ userInfo.reason }}</span>
          </p>
        </div>
        <el-form
          ref="registerRuleForm"
          :model="internalTestInfo"
          :rules="registerRules"
          label-width="120px"
          class="demo-ruleForm"
        >
          <div class="line">
            <el-form-item label="您的姓名" prop="name">
              <el-input
                maxlength="6"
                v-model="internalTestInfo.name"
                placeholder="请填写您的姓名"
              />
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="您的手机号" prop="phone">
              <el-input
                v-model="internalTestInfo.phone"
                placeholder="请填写您的手机号"
              />
            </el-form-item>
          </div>
          <div class="line pwd code" v-if="status != 2">
            <el-form-item label="短信验证码" prop="code">
              <el-input
                maxlength="6"
                class="yzm"
                v-model="internalTestInfo.code"
                placeholder="请输入短信验证码"
              />
              <span
                class="getCode"
                :style="{ color: registerCodeInfo.getCodeBtnColor }"
                @click="getCode"
              >
                {{ registerCodeInfo.getCodeText }}
              </span>
            </el-form-item>
          </div>
          <div class="line lineTextarea use">
            <el-form-item label="用途" prop="use">
              <el-input
                type="textarea"
                v-model="internalTestInfo.use"
                placeholder="请描述您使用岐黄问道大模型的用途"
                rows="6"
              ></el-input>
            </el-form-item>
          </div>

          <div class="line" style="display: none">
            <el-form-item label="从事的岗位" prop="title">
              <!-- <el-input v-model="internalTestInfo.title" placeholder="请选择您从事的岗位" /> -->
              <el-select
                style="width: 100%"
                v-model="internalTestInfo.title"
                class="m-2"
                placeholder="请选择您从事的岗位"
              >
                <el-option
                  v-for="item in titleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </div>
          <div class="line checkbox" style="display: none">
            <el-form-item
              label="您希望如何使用大经中医岐黄问道大模型？（多选）"
              prop="title"
            >
              <el-checkbox-group v-model="goalArr" text-color="#999999">
                <el-checkbox label="在线问诊" />
                <el-checkbox label="在线学习" />
                <el-checkbox label="闲聊" />
                <el-checkbox label="其他" />
              </el-checkbox-group>
            </el-form-item>
          </div>
          <!-- <div class="line checked">
							<el-checkbox v-model="registerChecked" />
							<span>
								阅读并同意《用户服务》和《隐私协议》,手机号将自动注册
							</span>
						</div> -->
          <div class="line login-line">
            <el-form-item>
              <!-- <el-button @click="submitForm">提交申请</el-button> -->
              <el-button
                v-if="internalTestInfo.role == 1"
                class="btn"
                :disabled="!uploadCertFlag"
                @click="submitForm"
                >提交申请</el-button
              >
              <el-button v-else class="btn" @click="submitForm"
                >提交申请</el-button
              >
            </el-form-item>
          </div>
          <div class="goLogin">
            <span @click="goLogin">已有账号？点我登录</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  defineComponent,
  getCurrentInstance,
  onMounted,
} from "vue";

import { Plus, ArrowLeft } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";

import { ElMessage } from "element-plus";
import { Uploader } from "vant";
import { useStore } from "vuex"; // 引入useStore 方法
// 手机号验证规则
const validatePhon = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入手机号码"));
  } else if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore(); // 该方法用于返回store 实例
    const uniHttp = getCurrentInstance().appContext.config.globalProperties;
    const globalImgPath = uniHttp.globalImgPath;
    const registerRuleForm = ref(null); // 注册form表单
    const loginRuleForm = ref(null); // 登录form表单
    const data = reactive({
      role: 2,
      //注册信息
      registerChecked: true,
      internalTestFlag: false, //内测申请
      goalArr: [],
      internalTestInfo: {
        hospital: "",
        address: "",
        name: "",
        title: "",
        phone: "",
        cert: "",
        role: 2,
        use: "",
        identity: "医疗行业从业者",
      },
      registerRules: {
        identity: [
          {
            required: true,
            message: "请选择您的身份",
            trigger: "change",
          },
        ],
        use: [
          {
            required: true,
            message: "请描述您使用岐黄问道大模型的用途",
            trigger: "blur",
          },
        ],
        hospital: [
          {
            required: true,
            message: "请填写医疗机构名称",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写您的姓名",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请填写您的职务",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePhon,
            trigger: "blur",
          },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        cert: [
          {
            required: true,
            message: "请上传您的医疗机构执业许可证",
            trigger: "submit",
          },
        ],
      },
      registerCodeInfo: {
        holdTime: 60,
        getCodeText: "获取验证码",
        getCodeBtnColor: "#001D7F",
        getCodeisWaiting: false,
        codeTimer: null,
      },
      titleOptions: [
        {
          value: "医务人员",
          label: "医务人员",
        },
        {
          value: "医疗行业从业者",
          label: "医疗行业从业者",
        },
        {
          value: "在校医学生",
          label: "在校医学生",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      fileList: [],
      fileData: null,
      imageUrl: "",
      imageUrlList: [],
      address: "",
      userInfo: null,
      status: "",
      uploadCertFlag: false,
    });

    const backHome = () => {
      router.go(-1);
    };
    //切换身份
    const changeRadio = (val) => {
      if (val == "医疗行业从业者") {
        data.internalTestInfo.role = 1;
        data.internalTestInfo.use = "";
      }
      if (val == "个人用户") {
        data.internalTestInfo.role = 2;
        data.internalTestInfo.hospital = "";
        data.internalTestInfo.address = "";
        data.internalTestInfo.title = "";
        data.internalTestInfo.cert = "";
        data.imageUrl = "";
        data.imageUrlList = [];
      }
    };
    //注册立即登录
    const submitForm = () => {
      if (data.internalTestInfo.role == 1) {
        registerRuleForm.value.validateField(
          ["hospital", "name", "identity", "title", "phone", "code", "cert"],
          (valid) => {
            if (valid) {
              if (data.internalTestInfo.id) {
                reRegister();
              } else {
                doctorSmsVerify(data.internalTestInfo, "register");
              }
            } else {
              return false;
            }
          }
        );
      }
      if (data.internalTestInfo.role == 2) {
        registerRuleForm.value.validateField(
          ["name", "identity", "phone", "code", "use"],
          (valid) => {
            if (valid) {
              if (data.internalTestInfo.id) {
                reRegister();
              } else {
                doctorSmsVerify(data.internalTestInfo, "register");
              }
            } else {
              return false;
            }
          }
        );
      }
    };

    //获取验证码
    const getCode = () => {
      if (data.registerCodeInfo.getCodeisWaiting) {
        return false;
      }
      data.registerCodeInfo.getCodeisWaiting = true;
      if (data.internalTestInfo.phone) {
        getDoctorSms(data.internalTestInfo.phone, "1");
      }
    };

    //定时器
    const setTimer = (registerCodeInfo) => {
      registerCodeInfo.getCodeText = "重新获取(60)";
      registerCodeInfo.codeTimer = setInterval(() => {
        if (registerCodeInfo.holdTime <= 0) {
          registerCodeInfo.getCodeisWaiting = false;
          registerCodeInfo.getCodeText = "获取验证码";
          registerCodeInfo.getCodeBtnColor = "#001D7F";
          clearInterval(registerCodeInfo.codeTimer); //清除该函数
          return; //返回前面
        }
        registerCodeInfo.getCodeBtnColor = "#333";
        registerCodeInfo.getCodeText =
          "重新获取(" + registerCodeInfo.holdTime + ")";
        registerCodeInfo.holdTime--;
      }, 1000);
    };

    //获取验证码
    const getDoctorSms = (phone, type) => {
      console.log(phone, type);
      uniHttp
        .$applicationJson("business/user/sms", {
          phone: phone,
          type: type,
        })
        .then((res) => {
          if (res.data.code == 200) {
            ElMessage({
              showClose: true,
              message: "验证码已发送",
              type: "success",
            });
            if (type == "1") {
              setTimer(data.registerCodeInfo); //调用定时器方法
              data.registerCodeInfo.getCodeisWaiting = false;
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
            if (type == "1") {
              data.registerCodeInfo.getCodeisWaiting = false;
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
          if (type == "1") {
            setTimer(data.registerCodeInfo); //调用定时器方法
            data.registerCodeInfo.getCodeisWaiting = false;
          }
        });
    };

    //验证码验证
    const doctorSmsVerify = (info, type) => {
      uniHttp
        .$applicationJson("business/user/sms/verify", {
          phone: info.phone,
          code: info.code,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (type == "register") {
              register();
            }
          } else {
            ElMessage({
              showClose: true,
              dangerouslyUseHTMLString: true,
              message: '<p style="width:140px">请输入正确的验证码</p>',
              type: "error",
              duration: 4000,
            });
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //保存登录信息
    const setLoginInfo = (res) => {
      window.localStorage.removeItem("role");
      window.localStorage.setItem("GptMToken", res.data.data.token);
      window.localStorage.setItem("userId", res.data.data.id);
      window.localStorage.setItem("role", 0);
      window.localStorage.setItem("gptLogin", 2); //默认只显示知病单轮
      window.localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      window.localStorage.setItem("loginFlag", true);
      store.commit("changeLogin", {
        GptMToken: res.data.data.token,
      });
      if (res.data.data.role == 0) {
        router.push({
          path: "/managementHome/managementHome",
        });
      } else {
        router.push({
          path: "/GptChartIndex/GptChartIndex",
        });
      }
    };

    //注册
    const register = () => {
      uniHttp
        .$applicationJson("business/user/register", {
          name: data.internalTestInfo.name,
          phone: data.internalTestInfo.phone,
          role: data.internalTestInfo.role,
          hospital: data.internalTestInfo.hospital,
          title: data.internalTestInfo.title,
          address: data.internalTestInfo.address,
          cert: data.internalTestInfo.cert,
          purpose: data.internalTestInfo.use,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (data.internalTestInfo.role == 1) {
              ElMessage({
                showClose: true,
                dangerouslyUseHTMLString: true,
                message:
                  '<p style="width:300px">等待审核中，审核通过后将会短信通知您!</p>',
                type: "success",
                duration: 4000,
              });
            }
            if (data.internalTestInfo.role == 2) {
              ElMessage({
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: '<p style="width:300px">注册成功</p>',
                type: "success",
                duration: 4000,
              });
              setLoginInfo(res);
            }

            /*
            if (res.data.data.token) {
              window.localStorage.setItem("GptMToken", res.data.data.token);
              window.localStorage.setItem("userId", res.data.data.id);
              window.localStorage.setItem("role", 0);
              window.localStorage.setItem("gptLogin", 2); //默认只显示知病单轮
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.data.data)
              );
              store.commit("changeLogin", {
                GptMToken: res.data.data.token,
              });
              window.localStorage.setItem("loginFlag", true);
              router.push({
                path: "/GptChartIndex/GptChartIndex",
              });
            }
            */
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //二次审核
    const reRegister = () => {
      uniHttp
        .$applicationJson("business/user/reRegister", {
          name: data.internalTestInfo.name,
          phone: data.internalTestInfo.phone,
          role: data.internalTestInfo.role,
          hospital: data.internalTestInfo.hospital,
          title: data.internalTestInfo.title,
          address: data.internalTestInfo.address,
          cert: data.internalTestInfo.cert,
          purpose: data.internalTestInfo.use,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (data.internalTestInfo.role == 1) {
              ElMessage({
                showClose: true,
                dangerouslyUseHTMLString: true,
                message:
                  '<p style="width:300px">等待审核中，审核通过后将会短信通知您!</p>',
                type: "success",
                duration: 4000,
              });
            }
            if (data.internalTestInfo.role == 2) {
              ElMessage({
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: '<p style="width:300px">注册成功</p>',
                type: "success",
                duration: 4000,
              });
              setLoginInfo(res);
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    const deleteImg = () => {
      data.imageUrl = "";
      //data.imageUrlList = [];
      data.internalTestInfo.cert = "";
      data.fileList = [];
      data.fileData = null;
      data.uploadCertFlag = false;
    };

    const getFile = (param) => {
      param.status = "uploading";
      param.message = "上传中...";
      var fileObj = param.file;
      const isLt20M = fileObj.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        ElMessage({
          showClose: true,
          message: "上传文件的大小不能超过20M!",
          type: "error",
        });
        return false;
      }
      // FormData 对象
      data.fileData = new FormData();
      // 文件对象
      data.fileData.append("file", fileObj);
      uploadCert(param);
    };
    //上传证书
    const uploadCert = (param) => {
      uniHttp
        .$multipartPost("business/user/upload/cert", data.fileData)
        .then((res) => {
          if (res.data.code == 0) {
            data.imageUrl = globalImgPath + res.data.data.path;
            data.internalTestInfo.cert = data.imageUrl;
            if (data.imageUrlList[0]) {
              data.imageUrlList[0].url = data.imageUrl;
            }
            param.status = "success";
            param.message = "";
            data.uploadCertFlag = true;
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //获取个人信息
    const getUserInfo = () => {
      data.imageUrlList = [];
      uniHttp
        .$applicationJson("business/user/info")
        .then((res) => {
          if (res.data.code == 0) {
            data.userInfo = res.data.data;
            data.internalTestInfo.name = res.data.data.name;
            data.internalTestInfo.phone = res.data.data.phone;
            data.internalTestInfo.hospital = res.data.data.hospital;
            data.internalTestInfo.id = res.data.data.id;
            data.internalTestInfo.title = res.data.data.title;
            data.internalTestInfo.goal = res.data.data.goal;
            data.internalTestInfo.address = res.data.data.address;
            if (res.data.data.cert) {
              data.internalTestInfo.cert = res.data.data.cert;
              data.imageUrl = res.data.data.cert;

              if (data.imageUrlList[0]) {
                data.imageUrlList[0].url = data.imageUrl;
              } else {
                data.imageUrlList.push({
                  url: data.imageUrl,
                });
              }
              data.uploadCertFlag = true;
            } else {
              data.uploadCertFlag = false;
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };
    const goLogin = () => {
      router.go(-1);
    };

    onMounted(() => {
      //let status = window.localStorage.getItem('status')
      data.status = route.query.status;
      if (data.status == 2) {
        getUserInfo();
      }
      if (route.query.tokenInvalid && route.query.tokenInvalid == "true") {
        ElMessage({
          showClose: true,
          message: "审核未通过,请重新注册",
          type: "warning",
        });
      }
    });

    return {
      Uploader,
      Plus,
      ArrowLeft,
      registerRuleForm,
      loginRuleForm,
      uniHttp,
      globalImgPath,
      ...toRefs(data),
      backHome,
      register,
      submitForm,
      getCode,
      doctorSmsVerify,
      getFile,
      deleteImg,
      changeRadio,
      setLoginInfo,
      goLogin,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.helloSvg-wrapper {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background: #fff;
  overflow-y: auto;
  position: absolute;
  .use {
    /deep/.el-form-item__error {
      top: 340% !important;
    }
  }

  .header {
    height: 4em;
    line-height: 4em;
    width: 100%;
    position: fixed;
    top: 0;
    display: none;
    .fold {
      margin-top: 1em;
      float: left;
      margin-left: 1em;
    }

    span {
      width: calc(100% - 5em);
      font-size: 16px;
      float: left;
      text-align: center;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; // 默认不换行；
    }
  }

  .login-content {
    position: absolute;
    top: 1em;
    width: 90%;
    margin-left: 5%;
    background: #fff;
    height: calc(100% - 1em);

    .top {
      width: 100%;
      overflow: hidden;

      img {
        width: 280px;
        margin: 0 auto;
      }

      span {
        color: #13171d;
        font-size: 40px;
        display: inline-block;
        line-height: 56px;
        float: left;
        margin-left: 10px;
      }
    }

    .center {
      margin-top: 20px;
      .userInfo {
        margin: 5px 0;
        p {
          span {
            float: left;
            width: 2.4rem;
            line-height: 0.6rem;
            font-size: 0.3rem;
            &:nth-child(1) {
              color: red;
            }
            &:nth-child(2) {
              width: calc(100% - 2.4rem);
            }
          }
        }
      }
      /deep/ .el-input__inner {
        //padding: 0.4rem 0;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.3rem;
      }

      .el-form-item {
        display: block;

        /deep/ .el-form-item__label {
          justify-content: flex-start;
          width: 360px !important;
          display: block;
          font-size: 0.3rem;
        }

        /deep/ .el-form-item__content {
          display: block;
          margin-left: 0px !important;
          height: 0.8rem !important;
          line-height: 0.8rem !important;
        }
      }
      .license {
        /deep/ .el-form-item__content {
          display: block;
          margin-left: 0px !important;
          height: 2.05rem !important;
          line-height: auto !important;
        }
      }

      .line {
        width: 100%;
        float: left;
        text-align: left;
        &.lineTextarea {
          margin-bottom: 100px;
        }
        /deep/ .el-form-item__error {
          font-size: 0.24rem;
          margin-top: 0.1rem;
        }
        .nam {
          color: #13171d;
          line-height: 20px;
          width: 72px;
          display: block;
        }

        .border {
          display: block;
          width: 20px;
          height: 2px;
          background: #001d7f;
          margin-left: 16px;
        }

        .login-btn {
          .el-button {
            width: 100%;
            height: 0.8rem;
            background: #001d7f;
            border-radius: 8px;
            margin: 0 auto;
            line-height: 0.8rem;
            text-align: center;
            color: #fff;
            font-size: 0.28rem;
            border: 1px solid #001d7f;
          }
        }

        .line-line {
          padding: 5px 0;

          .color {
            color: red;
            margin-right: 2px;
            margin-top: 4px;
            float: left;
          }

          span {
            font-size: 14px;
          }
        }
        .user-con {
          padding-bottom: 10px;
          float: left;
          /deep/ .avatar-uploader {
            margin: 20px 40px 5px 0px;
            .avatar {
              width: 80%;
              display: block;
              margin: 0 auto;
            }
            .el-upload {
              border: 1px dashed var(--el-border-color);
              border-radius: 6px;
              cursor: pointer;
              position: relative;
              overflow: hidden;
              transition: var(--el-transition-duration-fast);
              &:hover {
                border-color: var(--el-color-primary);
              }
            }

            .el-icon.avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              width: 80px;
              height: 80px;
              text-align: center;
              border: 1px dashed #ccc;
            }
          }
        }
      }
      .goLogin {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #001d7f;
      }

      .code {
        position: relative;

        .el-input {
          width: 100% !important;

          /deep/ .el-input__inner {
            width: 200px;
            overflow: hidden;
          }
        }

        .getCode {
          position: absolute;
          border-left: 1px solid #ccc;
          padding-left: 10px;
          color: #d65f4c;
          float: right;
          right: 10px;
          cursor: pointer;
          height: 100%;
          top: 0.02rem;
          font-size: 0.3rem;
        }
      }

      .login-line {
        text-align: center;
        .btn {
          width: 100%;
          height: 0.88rem;
          line-height: 0.88rem;
          background: #001d7f;
          margin: 0 auto;
          border-radius: 5px;
          text-align: center;
          color: #fff;
          font-size: 0.3rem;
        }
        .el-button {
          width: 100%;
          height: 0.8rem;
          background: #001d7f;
          border-radius: 8px;
          margin: 0 auto;
          line-height: 0.8rem;
          text-align: center;
          color: #fff;
          font-size: 0.28rem;
          border: 1px solid #001d7f;
        }

        .is-disabled {
          opacity: 0.8;
        }
      }

      .phone {
        .el-input {
          width: 300px;
        }
      }

      .pwd {
        .el-input {
          width: 180px;
        }

        .btn {
          width: 100px;
          display: inline-block;
          margin-left: 15px;
          cursor: pointer;
        }
      }

      .checked {
        font-size: 12px;

        .el-checkbox {
          float: left;
        }

        .span {
          display: inline-block;
          line-height: 34px;
          float: left;
          margin-left: 5px;

          .color {
            color: #001d7f;
            cursor: pointer;
          }
        }
      }

      .login-line {
        margin-top: 20px;
      }

      .checkbox {
        .el-checkbox {
          margin-right: 10px;
        }
      }

      .loginInfo {
        margin-top: 10px;
        width: 100%;
        float: left;
      }
    }
  }
}

.login-content2 {
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;

  .network_show {
    width: 100%;
    height: 100%;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.experience {
  color: #c9cbd1;
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
  padding-bottom: 40px;

  span {
    &:nth-child(2) {
      margin-left: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
    }
  }
}

.application {
  color: #41ae1b;
  margin-top: 10px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 18px;

  img {
    display: inline-block;
    width: 24px;
    margin-top: 8px;
    margin-right: 5px;
    float: left;
  }

  span {
    display: inline-block;
    float: left;
  }
}

.cta_content__zyHoI {
  cursor: pointer;
}

.cta_cta__pjYag {
  border-radius: 5px;
  height: 50px;
  padding: 0px 5px;
  font-size: 20px;
}

/deep/ .is-checked {
  --el-checkbox-checked-input-border-color: rgb(0, 29, 127);
  --el-checkbox-checked-bg-color: rgb(0, 29, 127);
  --el-radio-input-border: rgb(0, 29, 127);
  --el-radio-input-border-color: rgb(0, 29, 127);

  .el-radio__inner {
    background: rgb(0, 29, 127) !important;
  }

  .el-checkbox__label,
  .el-radio__label {
    color: rgb(0, 29, 127) !important;
  }
}

.image-animation {
  animation: image-pulse 1s ease-in;
}

@keyframes image-pulse {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
/deep/ .van-loading {
  margin-top: -10px;
}
/deep/ .van-uploader__mask-message {
  margin-top: 16px;
}
</style>
